module.exports = __webpack_public_path__ + "static/keyword_5-f60b6ea5a419867ecd88c32ebe40dce3.jpg";